module.exports = __webpack_public_path__ + "img/back.c215d3c4.webp";